import router from './router'
import store from './store'
import eventBus from './eventBus'
import { isModuleEnabled } from './helper'

function register (name, module) {
  if (!isModuleEnabled(name)) {
    return
  }

  store.commit('addModule', name)

  if (module.store) {
    store.registerModule(name, module.store)
  }

  if (module.router) {
    module.router(router)
  }

  if (module.eventBus) {
    eventBus.modules[name] = module.eventBus
  }

  if (module.managerParamsProvider) {
    store.commit(
      'manager/addParamsProvider',
      {
        name,
        callback: module.managerParamsProvider
      })
  }
}

export default function registerModules (modules) {
  Object.keys(modules).forEach(moduleKey => {
    const module = modules[moduleKey]
    register(moduleKey, module)
  })
}
